import { get, post, put, del } from './api';

//  Create a new product with image
export const createProduct = (data) => {
  return post('/products', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Get all products with pagination

export const getAllProducts = (
  page = 1,
  limit = 10,
  name = '',
  code = '',
  brand = '',
  category = '',
  status = '',
  sortField = 'id',      // default sort field
  sortOrder = 'desc'     // default sort order
) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (name) params.append('name', name);
  if (code) params.append('product_code', code);
  if (brand) params.append('brand_id', brand);
  if (category) params.append('category_id', category);
  if (status !== '') params.append('is_active', status);
  if (sortField) params.append('sort_field', sortField);
  if (sortOrder) params.append('sort_order', sortOrder);

  return get(`/products?${params.toString()}`);
};



//  Get a product by ID
export const getProductById = (id) => {
  return get(`/products/${id}`);
};

//  Update a product
export const updateProduct = (id, data, isMultipart = false) => {
  return put(`/products/${id}`, data, {
    headers: {
      "Content-Type": isMultipart ? "multipart/form-data" : "application/json",
    },
  });
};

//  Delete a product (soft delete if supported)
export const deleteProduct = (id) => {
  return del(`/products/${id}`);
};
